import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function FATValidityIcon({ className }: IconProps) {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3893)">
        <path
          d="M57.5223 8.24773H12.477C11.6311 8.24773 10.7852 7.61329 10.7852 6.55589C10.7852 5.70997 11.4196 4.86404 12.477 4.86404H57.5223C58.3682 4.86404 59.2142 5.49849 59.2142 6.55589C59.0027 7.61329 58.3682 8.24773 57.5223 8.24773Z"
          fill="#EAEEF9"
        />
        <path
          d="M34.8942 0C31.299 0 28.5498 2.74924 28.5498 6.34441V60.9063H41.2386V6.34441C41.2386 2.74924 38.4894 0 34.8942 0Z"
          fill="#EAEEF9"
        />
        <path
          d="M38.0661 6.76737C38.0661 8.45922 36.5857 9.93958 34.8939 9.93958C33.202 9.93958 31.7217 8.45922 31.7217 6.76737C31.7217 5.07553 33.202 3.59517 34.8939 3.59517C36.7972 3.59517 38.0661 4.86405 38.0661 6.76737Z"
          fill="#00416B"
        />
        <path
          d="M21.5711 41.8731C20.9367 41.8731 20.5137 41.4502 20.3022 41.0272L11.843 11.2085L3.17231 41.0272C2.96083 41.6616 2.32639 42.0846 1.69195 41.8731C1.05751 41.6616 0.634548 41.0272 0.846028 40.3928L10.5741 6.34441C10.7856 5.70997 11.2086 5.49849 11.843 5.49849C12.4774 5.49849 12.9004 5.92145 13.1119 6.34441L23.0515 40.3928C23.2629 41.0272 22.84 41.8731 22.2055 41.8731C21.7826 41.8731 21.7826 41.8731 21.5711 41.8731Z"
          fill="#00C4B3"
        />
        <path
          d="M68.097 41.8731C67.4626 41.8731 67.0396 41.4502 66.8282 41.0272L58.1575 11.2085L49.4868 41.0272C49.2753 41.6616 48.6408 42.0846 48.0064 41.8731C47.372 41.6616 46.949 41.0272 47.1605 40.3928L56.8886 6.34441C57.1001 5.70997 57.523 5.49849 58.1575 5.49849C58.7919 5.49849 59.2149 5.92145 59.4263 6.34441L69.3659 40.3928C69.5774 41.0272 69.1544 41.8731 68.52 41.8731C68.3085 41.8731 68.097 41.8731 68.097 41.8731Z"
          fill="#00C4B3"
        />
        <path
          d="M61.3298 6.76737C61.3298 8.45922 59.8494 9.93958 58.1576 9.93958C56.4657 9.93958 54.9854 8.45922 54.9854 6.76737C54.9854 5.07553 56.4657 3.59517 58.1576 3.59517C59.8494 3.59517 61.3298 4.86405 61.3298 6.76737Z"
          fill="#00416B"
        />
        <path
          d="M15.0153 6.76737C15.0153 8.45922 13.5349 9.93958 11.8431 9.93958C9.93978 9.93958 8.6709 8.45922 8.6709 6.76737C8.6709 5.07553 10.1513 3.59517 11.8431 3.59517C13.5349 3.59517 15.0153 4.86405 15.0153 6.76737Z"
          fill="#00416B"
        />
        <path
          d="M54.9846 65.5589H15.0148C13.7459 65.5589 12.6885 66.4048 12.6885 67.6737C12.6885 68.9426 13.7459 70 15.0148 70H54.9846C56.2534 70 57.3108 68.9426 57.3108 67.6737C57.0994 66.4048 56.2534 65.5589 54.9846 65.5589Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.9487 61.1178H22.84C21.5711 61.1178 20.5137 62.1752 20.5137 63.4441C20.5137 64.713 21.5711 65.7704 22.84 65.7704H46.9487C48.2176 65.7704 49.275 64.713 49.275 63.4441C49.275 61.9638 48.2176 61.1178 46.9487 61.1178Z"
          fill="#00C4B3"
        />
        <path
          d="M58.3691 28.7613C52.6591 28.7613 48.0065 32.9909 47.3721 38.4894C47.3721 39.3354 47.795 39.9698 48.641 39.9698H68.3086C69.1545 39.9698 69.789 39.3354 69.5775 38.4894C68.7316 32.9909 64.079 28.7613 58.3691 28.7613Z"
          fill="#00416B"
        />
        <path
          d="M57.946 23.2628C57.3115 26.0121 55.8312 28.3384 53.5049 29.8187C54.9852 30.6647 56.4656 31.2991 58.3689 31.2991C60.2723 31.2991 61.9641 30.6647 63.233 29.8187C61.3297 28.1269 60.0608 25.8006 59.6378 23.4743C59.0034 23.4743 58.3689 23.2628 57.946 23.2628Z"
          fill="white"
        />
        <path
          d="M64.2902 22.8399C64.2902 26.2236 61.5409 28.7613 58.3687 28.7613C55.1965 28.7613 52.4473 26.0121 52.4473 22.8399C52.4473 19.4562 55.1965 16.9184 58.3687 16.9184C61.5409 16.9184 64.2902 19.4562 64.2902 22.8399Z"
          fill="#00416B"
        />
        <path
          d="M23.0517 33.8369C23.0517 39.9698 17.9762 45.0453 11.8432 45.0453C5.71029 45.0453 0.634766 39.9698 0.634766 33.8369C0.634766 27.7039 5.71029 22.6284 11.8432 22.6284C17.9762 22.6284 23.0517 27.7039 23.0517 33.8369Z"
          fill="#00416B"
        />
        <path
          d="M21.5714 33.8369C21.5714 39.1239 17.1303 43.565 11.8433 43.565C6.34484 43.565 2.11523 39.1239 2.11523 33.8369C2.11523 28.5499 6.55632 24.1088 11.8433 24.1088C17.1303 24.1088 21.5714 28.3384 21.5714 33.8369Z"
          fill="#EAEEF9"
        />
        <path
          d="M14.381 27.4924L10.1514 33.2024L13.1121 34.6828L15.0154 27.9154C15.2269 27.281 14.8039 27.0695 14.381 27.4924Z"
          fill="#00C4B3"
        />
        <path
          d="M6.76729 31.7221L10.7854 34.6828L11.8428 32.568L6.97877 31.2991C6.76729 31.0876 6.55581 31.5106 6.76729 31.7221Z"
          fill="#00C4B3"
        />
        <path
          d="M13.9581 33.8369C13.9581 34.8943 13.1122 35.9517 11.8433 35.9517C10.7859 35.9517 9.72852 35.1057 9.72852 33.8369C9.72852 32.7795 10.5744 31.7221 11.8433 31.7221C12.9007 31.7221 13.9581 32.568 13.9581 33.8369Z"
          fill="#FBFCFE"
        />
        <path
          d="M12.9 33.8369C12.9 34.4713 12.477 34.8943 11.8426 34.8943C11.2081 34.8943 10.7852 34.4713 10.7852 33.8369C10.7852 33.2024 11.2081 32.7794 11.8426 32.7794C12.2655 32.7794 12.9 33.2024 12.9 33.8369Z"
          fill="#00C4B3"
        />
        <path
          d="M22.8399 39.9698H0.634441C0.21148 39.9698 0 40.1813 0 40.6042C0 45.4683 4.01813 49.4864 8.88217 49.4864H14.5921C19.4562 49.4864 23.4743 45.4683 23.4743 40.6042C23.4743 40.3928 23.2628 39.9698 22.8399 39.9698Z"
          fill="#00C4B3"
        />
        <path
          d="M69.3658 39.9698H46.9489C46.5259 39.9698 46.3145 40.1813 46.3145 40.6042C46.3145 45.4683 50.3326 49.4864 55.1966 49.4864H60.9066C65.7706 49.4864 69.7888 45.4683 69.7888 40.6042C70.0003 40.3928 69.5773 39.9698 69.3658 39.9698Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3893">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
